export { default as ApplePayButton } from "./ApplePayButton";
